import styled from "styled-components";

export default styled.div`
    margin-left: 20px;
    font-weight: bold;
    height: 100%;
    display: flex;
    align-items: center;
`;
